module.exports = __webpack_public_path__ + "static/media/loading.cbc07a4e.gif";